<template>
  <splash v-show="isLoading" title="수능모의평가 준비중..." />
  <splash v-show="isProc" title="잠시만 기다려 주세요." />
  <q-header reveal elevated class="bg-white text-black">
    <q-toolbar>
      <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
      <div style="display: flex; margin-left: 20px;">
        <q-btn flat icon="arrow_back_ios_new" :onClick="() => { nextExam(true); }" />
        <q-select filled v-model="model" use-input hide-selected fill-input input-debounce="0" :options="options"
          @filter="filterFn" style="width: 250px; ">
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No results
              </q-item-section>
            </q-item>
          </template>
        </q-select>
        <q-btn flat icon="arrow_forward_ios" :onClick="() => { nextExam(); }" />
      </div>
    </q-toolbar>
  </q-header>
  <q-page-container v-if="!scoreVisible">
    <q-page class="q-pa-md" style="height: calc(100vh - 150px)">
      <div class="row" v-if="isStart">
        <div class="col passage" style="height: calc(100vh - 70px)">
          <qbankHeaderVue :questionHeader="headerList[problem?.headerId] ? null : problem?.questionHeader"
            :inputIdx="inputIdx" :bookNm="bookNm" @isChangeHeader="() => { isChangeHeader = true; }"
            :reviewHeader="headerList[problem?.headerId]" />
        </div>
        <div class="col answer" style="height: calc(100vh - 70px)">
          <!-- <qbankProblem :p-content="problem" v-if="tab === item.index" @setCheckedAnswer="setCheckedAnswer"
              @onChangeProblems="onChangeProblems" @setProblemResult="setProblemResult" /> -->
          <q-scroll-area ref="scrollAreaRef" visible class="answer__scroll" style="height:100%;">
            <div>
              <problemChoice :p-content="problem" :isCsat="true" v-if="problem" @setAnswer="setAnswer" />
            </div>
            <div>{{
                problems[problemOrder]?.data.content.solution.answer.detail[0].answer
            }}</div>
            <div>
              <qbankAnswer :p-content="problem" v-if="problems[problemOrder]?.result" @onIntersection="onIntersection"
                @setVideoStatus="setVideoStatus" />
            </div>
          </q-scroll-area>
        </div>
      </div>
      <div v-if="!isStart" style="height: 100%;">
        <div style="text-align: center; justify-content: center; display: flex; align-items: center; height: 100%;">
          <div style="width: 60%; max-width: 1200px;">
            <div style="position: relative;align-items: center;display: inline-flex; margin-bottom: 1.41vmin;">
              <div
                style="border: 1px solid #000000; padding: 8px 30px; border-radius: 6vmin; font-size: 2.8vmin;font-weight: 700;">
                {{ studyStore?.level }}레벨 {{ studyStore?.process?.exam?.satOrder ?
                    (studyStore?.process?.exam?.satOrder + '회차') : ''
                }}
              </div>
            </div>
            <div style="font-size: 3vmin;color: #666666;">수능모의평가 문제지</div>
            <div
              style="font-size: 7.5vmin; font-weight: bold; margin-top: 3vmin; margin-bottom: 5vmin;font-family: Noto Serif KR;">
              국어 영역</div>
            <div
              style="width: 100%;justify-content: space-between; display: inline-flex; font-size: 2vmin;height: 14vmin; ">
              <div style="width: calc( 50% - 10px); margin-right: 10px; display: inline-flex; height:100%; ">
                <div
                  style="width: 150px;display: inline-flex;position: relative;align-items: center;text-align: center;justify-content: center;border: 1px solid #BDBDBD;font-weight: 700; background-color:#F7F7F7 ;border-top-left-radius: 1.33vmin;border-bottom-left-radius: 1.33vmin;">
                  <img src="@/assets/images/symbols/file-folder.png" style="height: 10vmin; padding-right: 5px;" />
                </div>
                <div
                  style="display: grid;position: relative;align-items: center;text-align: center;justify-content:center;border: 1px solid #BDBDBD;width: 100%;margin-left: -1px;border-top-right-radius: 1.33vmin;border-bottom-right-radius: 1.33vmin;">
                  <div>
                    <span style="font-size: 2.8vmin;font-weight: bold;">
                      34문항
                    </span><br />
                    <div>
                      (문학 17문항 /비문학 17문항)
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: calc( 50% - 10px); margin-left: 10px; display: inline-flex; height:100%;">
                <div
                  style="width: 150px;display: inline-flex;position: relative;align-items: center;text-align: center;justify-content: center;border: 1px solid #BDBDBD;font-weight: bold;background-color:#F7F7F7;border-top-left-radius: 1.33vmin;border-bottom-left-radius: 1.33vmin;">
                  <img src="@/assets/images/symbols/sandclock.png" style="height: 10vmin; padding-right: 5px;" />
                </div>
                <div
                  style="display: inline-flex;position: relative;align-items: center;text-align: center;justify-content:
                              center;border: 1px solid #BDBDBD; width: 100%;font-weight: 700;margin-left: -1px;font-size: 2.8vmin;border-top-right-radius: 1.33vmin;border-bottom-right-radius: 1.33vmin;">
                  60분
                </div>
              </div>
            </div>
            <div style="width: 100%;margin: 20px 0px;">
              <div
                style="width: 100%;border: 1px solid #BDBDBD;display: inline-grid; padding: 4.1vmin 3.25vmin;font-size: 2.16vmin;border-radius: 1.33vmin;">
                전체 34문항에 대한 답안 체크가 모두 완료되었을 경우 최종 제출이 가능하오니<br />
                한 문항도 빠짐없이 문제를 풀어 주시기 바랍니다. 평가가 시작되면 <b>60분동안 평가가 진행되며 중간에 종료할 수 없으므로 끝까지 문제를 풀어 주시기 바랍니다.</b>
              </div>
            </div>
            <!-- <div style="margin: 20px 0px;">
              <div
                style="width: 100%;border: 1px solid #000000;display: inline-grid; padding: 20px;font-weight: 500;background-color: #F7F7F7; font-size: 2.75vmin;">
                평가 시작버튼을 누르면 모의평가가 시작됩니다.
              </div>
            </div> -->
            <div style="width: 100%;display: inline-grid;">
              <q-btn :onClick="testStart" color="primary" label="평가시작"
                style="height: 7.5vh; font-size: 2vmin;border-radius: 1vmin;" />
            </div>
          </div>
        </div>
      </div>
      <FloatingNotify :text="msg" :icon="msgIcon" @resetMsg="() => { msg = '' }" />
      <!-- <FloatingBtn :visible="nextBtn" @on-click="() => { nextStep(); }" /> -->
      <FloatingBtn :visible="true" :text="problemOrder == 34 ? '완료' : ''" @on-click="() => { nextStep(); }"
        :bgColor="problemOrder == 34 ? '#FF4E7C' : null" :icon="problemOrder == 34 ? 'done' : null" />
      <FloatingBtn :visible="true" position="left" @on-click="() => { nextStep(false); }" />
      <FloatingBtn :visible="scoreBtn" text="정답 확인" text-only="true" bgColor="#FF4E7C" @on-click="setQuestionsResult"
        bottom="calc( 20vh - 55px )" />
    </q-page>
  </q-page-container>
  <template v-if="scoreVisible">
    <q-page-container>
      <div class="score">
        <div class="score__title">
          채점 결과
        </div>
        <div class="score__desc">
          평가가 종료되었습니다. 문항에 대한 정오답 여부를 확인해 보세요.
        </div>
        <div class="score__wrap" v-if="headerInfo">
          <div class="score__item" style="width: 50%;">
            <div class="score__item__title">문학</div>
            <div class="score__item__wrap">
              <div class="score__item__left">
                <template v-for="index in 9">
                  <div style="display: flex; padding: 0.8vmin 0;">
                    <div style="width: 50%; font-size: 2.2vmin;">{{ index }}</div>
                    <!-- <div>{{ headerInfo[index]?.result?.marking }}</div> -->
                    <div style="width: 50%;display: inline-flex;align-items: center;justify-content: center;">
                      <q-icon
                        :name="headerInfo[index]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        size="sm"
                        :style="headerInfo[index]?.result?.marking !== 'right' ? 'font-size: 2.2vmin;color:#FD6956 ;' : 'font-size: 2.2vmin;'">
                      </q-icon>
                    </div>
                  </div>
                </template>
              </div>
              <div class="score__item__right">
                <template v-for="index in 8">
                  <div style="display: flex;padding: 0.8vmin 0;">
                    <div style="width: 50%;font-size: 2.2vmin;">{{ index + 9 }}</div>
                    <div style="width: 50%;display: inline-flex;align-items: center;justify-content: center;">
                      <!-- <div>{{ headerInfo[index + 9]?.result?.marking }}</div> -->
                      <q-icon
                        :name="headerInfo[index + 9]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        size="sm"
                        :style="headerInfo[index + 9]?.result?.marking !== 'right' ? 'font-size: 2.2vmin;color:#FD6956 ;' : 'font-size: 2.2vmin;'">
                      </q-icon>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="score__item" style="width: 50%;">
            <div class="score__item__title">비문학</div>
            <div class="score__item__wrap">
              <div class="score__item__left">
                <template v-for="index in 9">
                  <div style="display: flex; padding: 0.8vmin 0;">
                    <div style="width: 50%;font-size: 2.2vmin;">{{ index + 17 }}</div>
                    <div style="width: 50%;display: inline-flex;align-items: center;justify-content: center;">
                      <!-- <div>{{ headerInfo[index + 17]?.result?.marking }}</div> -->
                      <q-icon
                        :name="headerInfo[index + 17]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        size="sm"
                        :style="headerInfo[index + 17]?.result?.marking !== 'right' ? 'font-size: 2.2vmin;color:#FD6956 ;' : 'font-size: 2.2vmin;'">
                      </q-icon>
                    </div>
                  </div>
                </template>
              </div>
              <div class="score__item__right">
                <template v-for="index in 8">
                  <div style="display: flex; padding: 0.8vmin 0;">
                    <div style="width: 50%;font-size: 2.2vmin;">{{ index + 26 }}</div>
                    <div style="width: 50%;display: inline-flex;align-items: center;justify-content: center;">
                      <!-- <div>{{ headerInfo[index + 26]?.result?.marking }}</div> -->
                      <q-icon
                        :name="headerInfo[index + 26]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        size="sm"
                        :style="headerInfo[index + 26]?.result?.marking !== 'right' ? 'font-size: 2.2vmin;color:#FD6956 ;' : 'font-size: 2.2vmin;'">
                      </q-icon>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 2.5vmin;">
          <q-btn style="background-color: #9411FF; color: white; font-size: 1.8vmin; padding: 1.2vmin 4vmin;"
            label="문항 해설 보기" :onClick="() => {
              scoreVisible = false; scoreBtn = false; nextStep(false, 1);
            }" />
        </div>
      </div>
    </q-page-container>
  </template>
</template>

<script setup>
import { historyBack } from "@/helpers/utils"
import splash from "@/components/template/splash.vue"
import { ref, onMounted, onUnmounted, watch, toRaw } from "vue";
import { DialogStore } from "@/store/modules/dialog";
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from "@/components/qbank/header.vue";
import problemChoice from "@/components/qbank/problemChoice.vue";
import qbankAnswer from "@/components/qbank/qbankAnswer.vue";
import AnswerMarking from "@/components/qbank/answerMarking.vue";
import CsatHeader from "@/components/layouts/header/csatHeader.vue";
import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtProblem } from "@/api/modules/qbank";
import dataToParse from "@/helpers/qbankParser/dataParse";
import { getHeaderTitle, getKreadScore, getHeaderText, getEtcInfo, getHeader } from "@/helpers/qbankParser/qbankDataParse";
import { useQuasar } from 'quasar'
import moment from "moment";
import { soundEffect, soundTic } from "@/helpers/soundEffect";
import { StudyStore } from "@/store/modules/study";
import { useRouter } from "vue-router"
import cqBtn from "@/components/quasar/cqBtn.vue"
import _ from "lodash"
import ProblemRelation from "@/components/qbank/problemRelation.vue";
import { analysis, difficult, drill } from "@/helpers/qbankParser/qbankMeta";
import { postSatStart, postSatEnd, postAnswer, getAnswer } from "@/api/modules/study";
import FloatingBtn from "@/components/quasar/floatingBtn.vue";
import FloatingNotify from "@/components/quasar/floatingNotify.vue";
import { examsDataEx } from "../testPage/examsData";

// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const loadingTime = 1000;
const store = DialogStore();
const studyStore = StudyStore();
const isLoading = ref(null);
const isProc = ref(null);
const isKreadVisible = ref(null);
const data = ref(null);
const diffTime = ref(null);
let startTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const resultData = ref([]);
let allProblems = [];
let notif = null;
let problemMaps = [];
let problems = {};
let baseProblems = {};
let drillProblems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false;  // 채점 표시

//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(1);
let problem = ref(null);
let notiAnswer = null;
let notiInfo = null;
let notiNav = null;
let notiAdditionalNav = null;
let notiNavBack = null;
let notiScoring = null;
let notiType = 'first';
let isScored = false;
let isDrill = false;



const dialog = ref(false);
const videoDialog = ref(false);
const resultDialog = ref(false);
const relationId = ref(null);
const scrollAreaRef = ref(null);
const headerInfo = ref([]);

const isStart = ref(false);
const isPause = ref(true);
const scoreVisible = ref(false);

const nextBtn = ref(false);
const preBtn = ref(false);
const scoreBtn = ref(false);
const msgComp = ref(false);
const msg = ref('');
const msgIcon = ref(null);
const isChangeHeader = ref(false);

let isViewMode = true;
let isAllChecked = false;

const headerList = ref({});
const baseTime = ref(0);

let cornerTime = {
  passageReadStartTs: null,
  passageReadEndTs: null,
  passageReadTime: 0,
  videoViewStartTs: null,
  videoViewEndTs: null,
  videoViewTime: 0,
  cornerLearningStartTs: null,
  cornerLearningEndTs: null,
  cornerLearningTime: 0,
}

const randomAnswer = () => {
  const ran = (Math.floor(Math.random() * 4) + 1);
  return ran === 1 ? '①' : ran === 2 ? '②' : ran === 3 ? '③' : ran === 4 ? '④' : '⑤';
}
const initCoreReading = (rs) => {
  isLoading.value = false;
  // if (sdata) {
  //   isStart.value = true;
  // }
  const tmpEtcInfo = getEtcInfo(rs);
  data.value = {
    content: getHeaderText(rs),
    kread: tmpEtcInfo.kread,
    title: tmpEtcInfo.title,
    etcInfo: tmpEtcInfo,
    standardReadingTime: moment('2022-10-01 00:00:00').add(tmpEtcInfo.solveTime, 's').format('m분ss초'),
    solveTime: tmpEtcInfo.solveTime
  };
  questionHeader.value = getHeader(rs);
  bookNm.value = tmpEtcInfo.bookNm;
  startTime = moment();
  cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
  // problems[problemOrder.value]['answerStartTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
  // if (!sdata) {
  //   setTimeout(() => {
  //     msg.value = '1번부터 4번까지 문제를 풀어보아요.';
  //   }, 1000)
  // }
}

const testStart = () => {
  isStart.value = true;
  isPause.value = false;
  // if (!isViewMode) {
  //   postSatStart({
  //     examName: studyStore.process.exam.examCode
  //     // examName: 'KRT_02_T1'
  //   }, () => {

  //   })
  // }
}

const nextStep = (v = true, no = -1) => {
    isProc.value = true;
    soundEffect('next');

  if (!isScored && no == -1 && problems[(problemOrder.value)] && problems[(problemOrder.value)]['result'] === null) {
    problems[(problemOrder.value)]['elapsedTime'] = problems[(problemOrder.value)]['elapsedTime'] + (moment.duration(moment().diff(startTime)).asSeconds());
    problems[problemOrder.value]['answerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  startTime = moment();
  if (no == -1 && problems[(problemOrder.value)] && problems[(problemOrder.value)]['result'] !== null) {
    problems[problemOrder.value]['completeYn'] = true;
  }

  if (notiType === 'last' && v) {
    if (isChangeHeader.value) {
      headerList.value = { ...headerList.value, [problems[problemOrder.value].headerId]: document.getElementById('header_box').innerHTML }
      isChangeHeader.value = false;
    }
    submitAnswer(problemOrder.value);
    return saveResult();
    // return router.push('/authenticreading');
  }

  if (no === -1) {
    if (isChangeHeader.value) {
      headerList.value = { ...headerList.value, [problems[problemOrder.value].headerId]: document.getElementById('header_box').innerHTML }
      isChangeHeader.value = false;
    }
    submitAnswer(problemOrder.value);
  }

  if (no !== -1) {
    problemOrder.value = Number(no);
  } else if (!v) {
    problemOrder.value = problemOrder.value - 1;
  } else {
    problemOrder.value = problemOrder.value + 1;
  }

  if (!problems[problemOrder.value]['answerStartTs']) {
    // problems[problemOrder.value]['answerStartTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
  }

  questionHeader.value === getHeader(problems[(problemOrder.value)].data)
  if (problemOrder.value === 1) {
    notiType = 'first'
    // questionHeader.value = getHeader(problems[(problemOrder.value)].data);
  } else if (problemOrder.value === Object.keys(problems).length) {
    notiType = 'last'
  } else {
    notiType = 'middle'
  }
  // problemOrder.value = problemOrder.value = 2;
  // getKrtProblem({
  //   version: '1.00.01', problemId: problemMaps[problemOrder.value].problemId
  // }, setProblem)
  problem.value = {
    ...problems[problemOrder.value]
  };

  if (problems[problemOrder.value]['completeYn']) {
    (notiType !== 'first') ? (preBtn.value = true) : (preBtn.value = false);
    nextBtn.value = true
  }
  else if (problems[problemOrder.value]['answer'] !== null && !isScored) {
    notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
    notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
  }
  else if (!problems[problemOrder.value]['completeYn'] || isScored) {
    preBtn.value = false;
    nextBtn.value = false;
  } else {
    notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
    notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
  }
  // setNotiNavigation(problems[problemOrder.value]);

  // notiNav !== null && notiNav();
  // notiNavBack !== null && notiNavBack();
  // notiNav = null;
  // notiNavBack = null;
  // startTime = moment();

  setScrollPosition();
  isProc.value = false;
}

const initExams = (e = null) => {
  getKrtExam({
    // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
    version: studyStore.exprVersion, examNm: e
    // version: studyStore.exprVersion, examNm: 'KRT_02_T1'
  }, async (rs) => {
    // TODO: store 에 코어리딩 문제 저장
    // rs.examMaps 
    if (rs && rs.examMaps) {
      const exId = rs.examIds[0];
      const problemArr = rs.examMaps[exId];

      let sOrder = 1;
      let tmpElapsedTime = 0;
      let lastProblem = {};
      // if (sdata) {
      //   let sdataIdxs = []
      //   sdata.forEach(i => {
      //     sdataIdxs.push(i.problemId);
      //     if (i.answerStatus === 'COMPLETE') {
      //       isScored = true;
      //     }
      //     if (i.completeYn) {
      //       lastProblem = i;
      //     }
      //     tmpElapsedTime += Number(i.elapsedTime);
      //   });
      //   if (sdataIdxs.length > 33) {
      //     isAllChecked = true;
      //   }

      //   problemArr.forEach((item, index) => {
      //     if (sdataIdxs.includes(item.problemId)) {
      //       if (isScored) {
      //         if (lastProblem.problemId === item.problemId) {
      //           sOrder = (index + 1);
      //         }
      //       } else {
      //         sOrder = (index + 1);
      //       }
      //     }
      //   });
      // }
      let tmpPdata = {};
      await Promise.all(
        problemArr.map((item, index) => {
          return getKrtProblem({
            version: studyStore.exprVersion, problemId: item.problemId
            // version: '1.00.01', problemId: 382222
          }, (r) => {
            headerInfo.value = { ...headerInfo.value, [index + 1]: { answer: null, correctFlag: null } }
            let pData = {
              problemNo: index + 1,
              problemId: r.content.problemId,
              analysisOrd: item.analysisOrd,
              etcInfo: getEtcInfo(r),
              data: r,
              questionHeader: getHeader(r),
              type: studyStore.process.exam.ln,
              elapsedTime: 0,
              answer: null,
              // 테스트를 위해 임시 답 생성
              // answer: randomAnswer(),
              reAnswer: null,
              videoTime: 0,
              relationResult: null,
              // 하단 네비 조정을 위한 변수
              result: null,              // 채점 여부및 1,2차 정오답 
              completeYn: false,               // 채점및 풀이 확인 완료여부
              scrollCheck: false,             // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
              relationId: r.content.property.problem?.relations?.length > 0 ? r.content.property.problem?.relations[0].relationId : null,           // 확인 문제 있는지 여부
              // relationId: null,           // 확인 문제 있는지 여부
              completeVideo: false,         // 영상 시청 여부
              correct: r.content.solution.answer.detail[0].answer,
              // TODO: 큐뱅크 해설영상 파싱필요 
              // videoUrl: null,              // 해설 영상 여부
              videoUrl: r.content.property.problem.listen.includes('mp4') ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
              // videoUrl: r.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
              // videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
              problemClassCode: '1',
              headerId: r.content.property.header.headerId,
              answerStartTs: null,
              answerEndTs: null
            };

            // headerList.value = { ...headerList, [r.content.property.header.headerId]: getHeader(r) }

            // if (sdata) {
            //   const tmpData = ([...sdata].filter(i => i.problemId === r.content.problemId)).pop();
            //   if (tmpData) {
            //     pData = {
            //       ...pData,
            //       completeYn: tmpData.completeYn,
            //       answer: tmpData.answer,
            //       correctYn: tmpData.correctYn,
            //       result: tmpData.answerStatus === 'COMPLETE' ? { marking: tmpData.correctYn ? 'right' : 'wrong', answer: tmpData.answer } : null,
            //       elapsedTime: tmpData.elapsedTime,
            //       answerStartTs: tmpData.answerStartTs,
            //       answerEndTs: tmpData.answerEndTs,
            //       problemClassCode: tmpData.problemClassCode
            //     }
            //   }
            //   if (tmpData?.reviewContents) {
            //     headerList.value = { ...headerList.value, [pData.headerId]: tmpData?.reviewContents }
            //   }
            // }
            tmpPdata = {
              ...tmpPdata,
              // TODO: 문항 검수용 전체 문제 보기
              [index + 1]: pData
            }
          });
        })
      );
      problems = tmpPdata;

      // if (sdata && sOrder) {
      //   console.log(sOrder);
      //   console.log(problems);
      //   console.log(problems[sOrder]);
      //   problemOrder.value = sOrder;
      //   problem.value = problems[sOrder];
      //   initCoreReading((problems[sOrder]?.data), sdata);
      //   baseTime.value = tmpElapsedTime;
      //   if (!isScored) {
      //     isPause.value = false;
      //   }
      //   if (problems[sOrder].completeYn || !isScored) {
      //     sOrder !== 1 && (preBtn.value = true);
      //     nextBtn.value = true;
      //     if (sOrder === 34) {
      //       notiType = 'last';
      //     } else if (sOrder === 1) {
      //       notiType = 'first';
      //     } else {
      //       notiType = 'middle';
      //     }
      //   }
      //   if (isAllChecked && !isScored) {
      //     scoreBtn.value = true;
      //   }
      // } else {
      // }
      initCoreReading(problems[1].data);
      problem.value = problems[1];

    }
  });
}


onMounted(() => {
  isStart.value = true;
  isPause.value = false;
  initExams(stringOptions[0]);
  // isLoading.value = true;
  // initExams(newValue);
  // setTimeout(() => { initExams(); }, 1000);
  // if (studyStore.currentInfo !== null) {
  //   isViewMode = true;
  //   getAnswer({ type: 'sat', data: { examName: studyStore.currentInfo.exam.examCode, learningType: studyStore.currentInfo.exam.learningType } }, (r) => {
  //     setTimeout(() => { initExams(r); }, 1000);
  //   });
  // } else {
  //   if (studyStore.process.exam.learningStatus === 'I') {
  //     getAnswer({ type: 'sat', data: { examName: studyStore.process.exam.examCode, learningType: studyStore.process.exam.learningType } }, (r) => {
  //       if (r?.length > 0) {
  //         setTimeout(() => { initExams(r); }, 1000);
  //       } else {
  //         setTimeout(() => { initExams(); }, 1000);
  //       }
  //     });
  //   } else if (studyStore.process.exam.learningStatus === 'C') {
  //     getAnswer({ type: 'sat', data: { examName: studyStore.process.exam.examCode, learningType: studyStore.process.exam.learningType } }, (r) => {
  //       if (r?.length > 0) {
  //         setTimeout(() => { initExams(r); }, 1000);
  //       } else {
  //         setTimeout(() => { initExams(); }, 1000);
  //       }
  //     });
  //   } else if (studyStore.process.exam.learningStatus === 'W') {
  //     setTimeout(() => { initExams(); }, 1000);
  //   }
  // }
})


const answerNoti = () => {
  notiAnswer !== null && notiAnswer();
  notiAnswer = null;
  scoreBtn.value = true;
}

onUnmounted(() => {
  isLoading.value = true;
})


watch(() => studyStore.process, (newValue) => {
  isLoading.value = true;
  if (studyStore.currentInfo !== null) {
    isViewMode = true;
    getAnswer({ type: 'sat', data: { examName: studyStore.currentInfo.exam.examCode, learningType: studyStore.currentInfo.exam.learningType } }, (r) => {
      setTimeout(() => { initExams(r); }, 1000);
    });
  } else {
    if (studyStore.process.exam.learningStatus === 'I') {
      getAnswer({ type: 'sat', data: { examName: studyStore.process.exam.examCode, learningType: studyStore.process.exam.learningType } }, (r) => {
        if (r?.length > 0) {
          setTimeout(() => { initExams(r); }, 1000);
        } else {
          setTimeout(() => { initExams(); }, 1000);
        }
      });
    } else if (studyStore.process.exam.learningStatus === 'C') {
      getAnswer({ type: 'sat', data: { examName: studyStore.process.exam.examCode, learningType: studyStore.process.exam.learningType } }, (r) => {
        if (r?.length > 0) {
          setTimeout(() => { initExams(r); }, 1000);
        } else {
          setTimeout(() => { initExams(); }, 1000);
        }
      });
    } else if (studyStore.process.exam.learningStatus === 'W') {
      setTimeout(() => { initExams(); }, 1000);
    }
  }
});
watch(() => problem, (newValue) => {
  //
});


const setAnswer = (val) => {
  // soundEffect('tic');

  problems[problemOrder.value]['answer'] = val;
  const tmpAnswerArr = _.filter(problems, item => { return item.answer === null });
  if (tmpAnswerArr.length === 0) {
    isAllChecked = true;
    scoreBtn.value = true;
  }
  notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
  notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
  headerInfo.value = { ...headerInfo.value, [problemOrder.value]: { answer: val, correctFlag: null } }
}


const setQuestionsResult = () => {
  if (!problems[problemOrder.value]['answerEndTs']) {
    problems[problemOrder.value]['answerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  problems[(problemOrder.value)]['elapsedTime'] = problems[(problemOrder.value)]['elapsedTime'] + (moment.duration(moment().diff(startTime)).asSeconds());
  startTime = moment();
  const tmpData = [];
  Object.entries(problems).forEach(([key, item]) => {
    const tmpIsRight = item.data.content.solution.answer.detail[0].answer === item.answer;
    if (tmpIsRight) {
      tmpData.push({ no: item.analysisOrd, marking: 'right', analysis: item.data.content.property.analysis.analysisNm, difficult: difficult[item.data.content.property.analysis.difficultCd].label })
    } else {
      tmpData.push({ no: item.analysisOrd, marking: 'wrong', analysis: item.data.content.property.analysis.analysisNm, difficult: difficult[item.data.content.property.analysis.difficultCd].label })
    }
    item.result = { marking: tmpIsRight ? 'right' : 'wrong', answer: item.answer };
  });
  // 헤더에 정답여부셋
  headerInfo.value = { ...problems };
  const total = _.countBy(tmpData, (i) => {
    return i.marking === 'right' ? 'right' : 'wrong';
  });
  resultData.value = { ...total, data: tmpData };

  Object.entries(problems).forEach(([key, item]) => {
    submitAnswer(key);
  });

  isScored = true;
  scoreVisible.value = true;
  isPause.value = true;
}

// 스크롤 하단시 액션
const onIntersection = () => {
  if (problems[problemOrder.value]['scrollCheck'] !== true) {
    problems[problemOrder.value]['scrollCheck'] = true;
    if (problem.value?.result?.marking === 'right') {
      problems[problemOrder.value]['completeYn'] = true;
      problems[problemOrder.value]['completeVideo'] = true;
      (notiType !== 'first' || isDrill) ? (preBtn.value = true) : (preBtn.value = false);
      nextBtn.value = true
    } else {
      if (problems[problemOrder.value]['videoUrl'] !== null) {
        msgIcon.value = '';
        // msg.value = '확인해야 할 해설영상이 있어요!';
        msg.value = '문제풀이 영상을 확인하세요.';
      } else if (problems[problemOrder.value]['videoUrl'] === null && problems[problemOrder.value]['relationId'] === null) {
        problems[problemOrder.value]['completeYn'] = true;
        (notiType !== 'first' || isDrill) ? (preBtn.value = true) : (preBtn.value = false);
        nextBtn.value = true
      } else {
        (notiType !== 'first' || isDrill) ? (preBtn.value = true) : (preBtn.value = false);
        nextBtn.value = true
      }
    }
    // setNotiNavigation(problems[problemOrder.value]);
  }
}

const setVideoStatus = () => {
  problems[problemOrder.value]['completeVideo'] = true;
  (notiType !== 'first' || isDrill) ? (preBtn.value = true) : (preBtn.value = false);
  nextBtn.value = true
  // setNotiNavigation(problems[problemOrder.value]);
  // console.log(problems[problemOrder.value]);
}

const setScrollPosition = (val = 0) => {
  scrollAreaRef.value.setScrollPosition('vertical', 0);
}


const saveResult = () => {
  // if (isViewMode) {
  //   router.push('/satreport');
  // } else {
  //   if (!isViewMode) {
  //     postSatEnd({

  //       examName: studyStore.process.exam.examCode,
  //       // examName: 'KRT_02_T1',
  //     }, (r) => {

  //       studyStore.report.level = studyStore.level;
  //       studyStore.report.lesson = studyStore.lesson;
  //       studyStore.report.areaCode = studyStore.process.exam.areaCode;
  //       // TODO: 추천학습 맞춤학습이 확정되면 수정 필요
  //       // studyStore.report.learningTypeCode = learningType[studyStore.process.exam.learningType].code;
  //       studyStore.report.learningType = studyStore.process.exam.learningType;
  //       studyStore.report.learningHistorySeq = r.learningHistorySeq;

  //       getUserMain((rs) => {
  //         console.log(rs)
  //         let tmpMapTree = [];
  //         let tmpStudy = { '01': [], '02': [] };
  //         rs.studyMain.forEach(element => {
  //           tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
  //           tmpMapTree.push({
  //             // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
  //             examCode: element.examName,
  //             version: rs.exprVersion,
  //             // TODO: 변경해야함
  //             headerEtcCd02: element.areaCode === '01' ? '05' : '02',
  //             headerEtcCd01: element.passageClass,
  //             title: element.passageName,
  //             areaCode: element.areaCode,
  //             isDone: false,
  //             learningStatus: element.learningStatus,
  //             learningType: element.learningType,
  //             difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
  //             satOrder: element?.satOrder ? element?.satOrder : null
  //           });
  //         });
  //         studyStore.level = rs.level;
  //         studyStore.lesson = rs.lesson;
  //         studyStore.exprVersion = rs.exprVersion;
  //         console.log(tmpMapTree);
  //         studyStore.mapTree.exams = tmpMapTree;
  //         // studyStore.difficultyL = JSON.parse(rs.difficultyL);
  //         // studyStore.difficultyN = JSON.parse(rs.difficultyN);
  //         // TODO: 변경 필요함
  //         const fIndex = _.findIndex(rs.studyMain, function (o) { return o.examName === rs.currentStart.examName; });
  //         studyStore.process.examIdx = fIndex;
  //         if (rs.studyMain[fIndex].learningStatus === 'W') {
  //           studyStore.process.studyTree = 5082;
  //         }
  //         studyStore.process.problemOrd = 0;
  //         studyStore.process.exam = {
  //           // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
  //           examCode: rs.currentStart.examName,
  //           version: rs.exprVersion,
  //           // TODO: 변경해야함
  //           headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
  //           headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
  //           title: rs.studyMain[fIndex].passageName,
  //           areaCode: rs.currentStart.areaCode,
  //           isDone: false,
  //           learningType: rs.currentStart.learningType,
  //           learningStatus: rs.studyMain[fIndex]?.learningStatus,
  //           difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
  //           satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null
  //         };

  //         console.log(studyStore);
  //         // postUserJson(JSON.stringify(studyStore.process), (rs) => {
  //         //   //
  //         // });

  //         router.push('/satreport');
  //       });

  //     })
  //   }
  // }
}



const submitAnswer = (num) => {
  let tmpVal = { ...problems[num] };
  if (tmpVal) {

    tmpVal.answer = tmpVal.answer;
    tmpVal.reAnswer = null;
    if (isScored) {
      tmpVal.elapsedTime = null;
      tmpVal.answerStartTs = null;
      tmpVal.answerEndTs = null;
    }
    if (headerList.value[tmpVal.headerId]) {
      tmpVal.reviewContents = headerList.value[tmpVal.headerId];
    }
    // tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
    tmpVal.correctYn = tmpVal.result === null ? null : (tmpVal.result?.marking === 'right');
    tmpVal.reCorrectYn = null;
    tmpVal.answerStatus = isAllChecked ? 'COMPLETE' : 'NOT_SCORE';

    delete tmpVal.data;
    delete tmpVal.result;
    delete tmpVal.rightAnswer;

    delete tmpVal.problemNo;
    delete tmpVal.analysisOrd;
    delete tmpVal.etcInfo;
    delete tmpVal.videoTime;
    delete tmpVal.relationResult;
    delete tmpVal.scrollCheck;
    delete tmpVal.relationId;
    delete tmpVal.completeVideo;

    delete tmpVal.videoUrl;
    delete tmpVal.completeVideo;
    delete tmpVal.questionHeader;
    delete tmpVal.type;
    delete tmpVal.headerId;

    const saveData = {
      examName: studyStore.process.exam.examCode,
      // examName: 'KRT_02_T1',
      exprVersion: studyStore.exprVersion,
      learningType: 'SAT',
      // learningType: studyStore.process.exam.learningType,
      cornerTime: {
        cornerLearningStartTs: cornerTime.cornerLearningStartTs,
        cornerLearningEndTs: moment().format('YYYY-MM-DD HH:mm:ss'),
        cornerLearningTime: (moment.duration(moment().diff(moment(cornerTime.cornerLearningStartTs))).asSeconds())
      },
      submission: { ...tmpVal }
    }
    // console.log('saveData %%%%%%%%%%%%%%%%%%%%%%%%%');
    // console.log(saveData);
    // console.log(JSON.stringify(saveData));
    // if (!isViewMode) {
    //   postAnswer({ type: 'sat', data: saveData }, () => {
    //     console.log('save Answer!');
    //   });
    // }

    // cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
  }
}

const model = ref(null);

const options = ref(stringOptions);

// const stringOptions = ["KRT_01_T1", "KRT_01_T2", "KRT_02_T1", "KRT_02_T2", "KRT_03_T1", "KRT_03_T2"];
const stringOptions = examsDataEx;
model.value = stringOptions[0];

const filterFn = (val, update, abort) => {
  update(() => {
    const needle = val.toLowerCase()
    options.value = [...stringOptions].filter(v => v.toLowerCase().indexOf(needle) > -1)
  })
}

const nextExam = (back = false) => {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
  console.log(stringOptions);
  console.log(model.value);
  // const fIndex = stringOptions.findIndex((e, i) => { e === model.value });
  const fIndex = _.findIndex(stringOptions, function (o) { return o === model.value; });
  console.log(fIndex);
  if (back) {
    if (fIndex !== 0)
      model.value = stringOptions[fIndex - 1]
  } else {
    if (fIndex !== stringOptions.length - 1)
      model.value = stringOptions[fIndex + 1]
  }
}


watch(() => model.value, (newValue) => {
  isLoading.value = true;
  problemOrder.value = 0;
  isStart.value = true;
  isPause.value = false;
  notiType = 'first';
  initExams(newValue);
});

const onClickHome = () => {
  store.openConfirmDialog({
    message: '중단하고 홈으로 이동하시겠습니까?',
    cancel: '닫기',
    ok: '확인',
    callback: () => { router.push('/learninghome') },
  });
}
</script>

<style scoped lang="scss">
.word-chart_item {
  padding: 0px 20px;
  text-align: center;
}

.q-dialog__backdrop {
  width: 100vw;
  height: 100vh;
  top: 0px;
  position: fixed;
  z-index: 6000;
  pointer-events: all;
  outline: 0;
  background: rgb(23 20 20 / 40%);
}

.score {
  // display: grid;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin-top: 5vh;
  display: block;
  width: 100%;

  &__title {
    font-size: 4vmin;
    font-weight: 700;
  }

  &__desc {
    margin-top: 1.2vh;
    font-size: 2vmin;
    font-weight: 400;
  }

  &__wrap {
    display: inline-flex;
    width: 60%;
    max-width: 1200px;
    min-width: 600px;
    margin-top: 1.2vh;
  }

  &__item {
    background-color: white;
    border-radius: 1vmin;
    margin: 0 0.8vmin;
    width: calc(50% - 0.8min);
    padding: 1vmin;

    &__title {
      background-color: #F7F7F7;
      font-size: 1.5vmin;
      font-weight: 700;
      padding: 1.2vmin 0;
      width: 100%;
    }

    &__wrap {
      display: flex;
      margin-top: 2.2vmin;
    }

    &__left {
      width: 50%;
      border-right: 1px solid #BDBDBD;
    }

    &__right {
      width: 50%;
    }
  }
}
.passage {
  +.answer {
      &::before {
          content: '';
          position: absolute;
          top: 46%;
          left: 0;
          width: 1px;
          height: 91%;
          max-height: 974px;
          background: $color_gray_500;
          @include transform(translateY(-50%));
      }
  }
}

.answer {
  position: relative;
  // padding: 0 4.17vmin;

  &__scroll {
    padding: 0 5.17vmin 3.33vmin 4.08vmin;
      // padding-right: 5.17vmin;
      // padding-bottom: 3.33vmin;
  }
}

::v-deep {
  .q-scrollarea__content {
    padding-bottom: 3.33vmin;
  }

  .q-scrollarea__bar--v,
  .q-scrollarea__thumb--v {
      width: 0.3vw;
  }
}
</style>
